'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

var _slice = require('./slice');

var _slice2 = _interopRequireDefault(_slice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _prep2.default)({
    name: 'shift',
    immutable: 'shift',
    array: function array() {
        return (0, _slice2.default)(1);
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/shift.js
// module id = 394
// module chunks = 35783957827783